import { BrowserRouter } from "react-router-dom";
import RoutesApp from "./routes";
import UserProvider from "./contexts/user";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <ToastContainer autoClose={2000}/>
        <RoutesApp/>
      </UserProvider>
    </BrowserRouter>
  );
}
